import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog'

interface TemplatePreviewDialogProps {
  isOpen: boolean
  onClose: () => void
  html: string
  templateName: string
}

export function TemplatePreviewDialog({
  isOpen,
  onClose,
  html,
  templateName
}: TemplatePreviewDialogProps) {
  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="sm:max-w-[700px] max-h-[95vh]">
        <DialogHeader>
          <DialogTitle>Önizleme: {templateName}</DialogTitle>
        </DialogHeader>

        <div className="border rounded-lg overflow-hidden bg-gray-100">
          <div className="bg-white">
            <iframe
              srcDoc={html}
              title="Email Preview"
              className="w-full h-[70vh] border-0"
              sandbox="allow-same-origin allow-popups allow-popups-to-escape-sandbox"
            />
          </div>
        </div>

        <div className="text-xs text-muted-foreground text-center">
          Bu, email'in alıcının gelen kutusunda nasıl görüneceğinin bir önizlemesidir.
        </div>
      </DialogContent>
    </Dialog>
  )
}
